/**
 * Interfaces du portail d'administration et droits associés.
 *
 * Partagé entre le backend (contrôle des droits) et le navigateur (tuiles du
 * portail, cases à cocher de la gestion des accès). Une clé ajoutée ici devient
 * un droit attribuable ; elle doit rester stable car elle est enregistrée en base.
 *
 * Le droit `access` (administrateur) donne accès à toutes les interfaces.
 */

const ADMIN_INTERFACES = [
  {
    key: 'mail',
    label: 'E-mails automatiques',
    description: 'Modèles Mailjet, profils étudiants, étapes de déclenchement et suivi des envois.',
    path: '/admin/mails',
    icon: 'send'
  },
  {
    key: 'exchanges',
    label: 'Étudiants en échange',
    description: 'Sessions, dossiers et imports des étudiants en échange.',
    path: '/admin/echanges',
    icon: 'globe'
  },
  {
    key: 'salesforce',
    label: 'Formulaires et correspondances',
    description: 'Modifier le modèle des échanges et les correspondances des formulaires vers Salesforce.',
    path: '/admin/salesforce',
    icon: 'link'
  },
  {
    key: 'access',
    label: 'Gestion des accès',
    description: 'Comptes administratifs et droits sur chaque interface.',
    path: '/admin/acces',
    icon: 'shield',
    superadmin: true
  }
];

const INTERFACE_KEYS = ADMIN_INTERFACES.map((item) => item.key);
const SUPERADMIN_KEY = 'access';

/** Droits réellement ouverts : l'administrateur reçoit toutes les interfaces. */
function effectivePermissions(granted) {
  const list = (Array.isArray(granted) ? granted : []).filter((key) => INTERFACE_KEYS.includes(key));
  return list.includes(SUPERADMIN_KEY) ? INTERFACE_KEYS.slice() : list;
}

function hasPermission(granted, key) {
  return effectivePermissions(granted).includes(key);
}

module.exports = { ADMIN_INTERFACES, INTERFACE_KEYS, SUPERADMIN_KEY, effectivePermissions, hasPermission };
